<template>
  <div>
    <v-btn
      class="mx-2"
      color="primary"
      fab
      small
      @click="updateAudioList(); showDialog = true"
      :disabled="buttonDisabled"
    >
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <slot>
            <v-icon
              v-bind="attrs"
              v-on="on"
              dark
            >
              mdi-microphone-plus
            </v-icon>
          </slot>
        </template>
        Generate Text to Speech
      </v-tooltip>
    </v-btn>
    <v-dialog
      v-if="showDialog"
      v-model="showDialog"
      max-width="75%"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Generate Text to Speech: {{ poiId }} {{ poiName }}</span>
        </v-card-title>

        <v-card-text>
          <AudioList
            :items="audioList"
          >
            <template v-slot:actions="slotProps">
              <v-btn
                v-if="!hasSomeAbilities($constants.ABILITY.INTERN)"
                icon @click="callDeleteAudioDialog(slotProps.item)"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }" >
                    <slot>
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        color="red"
                      >
                        mdi-delete
                      </v-icon>
                    </slot>
                  </template>
                  delete audio
                </v-tooltip>
              </v-btn>
            </template>
          </AudioList>
          <div class="red--text text-h6">
            If audio ({{ poiId }}_headline_description_.*_speech.mp3)
            already exist, it will be overwritten!!!
          </div>
        </v-card-text>

        <v-card-actions>
          <div>
            <v-autocomplete
              v-model="voice"
              :items="voicesSelect"
              label="Voice"
              item-text="name"
              item-value="id"
            />
          </div>
          <v-btn
            :loading="loading"
            color="blue darken-1"
            text
            @click="generateAudio()"
          >
            Generate
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="cancel"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AudioDialogDelete
      v-if="!hasSomeAbilities($constants.ABILITY.INTERN)"
      :name="deleteAudioDialog.audioDescription"
      :show.sync="deleteAudioDialog.show"
      :audioId="deleteAudioDialog.audioId"
      @deleted="deleteAudio"
    />
  </div>

</template>

<script>

import { mapActions } from 'vuex';
import AudioDialogDelete from './AudioDialogDelete.vue';
import AudioList from '../AudioList.vue';

export default {
  name: 'PoiDialogTextToSpeech',
  components: {
    AudioDialogDelete,
    AudioList,
  },
  props: {
    poiId: {
      type: String,
      default: null,
    },
    poiName: {
      type: String,
      default: null,
    },
    show: {
      type: Boolean,
    },
    buttonDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    showDialog: false,
    loading: false,
    disabled: false,
    audioList: [],
    voice: 0,
    voicesSelect: [
      { id: 0, name: 'Random' },
      { id: 1, name: 'Wavenet-I' },
      { id: 2, name: 'Wavenet-F' },
      { id: 3, name: 'Studio-O' },
    ],
    deleteAudioDialog: {
      show: false,
      audioId: null,
      audioDescription: null,
    },
  }),
  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),
    cancel() {
      this.showDialog = false;
      this.loading = false;
      this.disabled = false;
    },
    updateAudioList() {
      this.$requestHelpers
        .get(`api/admin/audio/playlist/poi/${this.poiId}`)
        .then((response) => {
          this.audioList = response.data;
        });
    },
    generateAudio() {
      this.loading = true;
      this.disabled = true;

      this.$requestHelpers
        .post(`api/admin/poi/textToSpeech/${this.poiId}`, { voice: this.voice })
        .then((response) => {
          if (response.data.error ?? true) {
            this.setSnack({
              color: 'red',
              text: 'error',
            });
          } else {
            this.setSnack({
              color: 'green',
              text: 'saved',
            });
          }
        }).catch(() => {
          this.setSnack({
            color: 'red',
            text: 'error',
          });
        })
        .finally(() => {
          this.loading = false;
          this.disabled = false;
          this.updateAudioList();
        });
    },

    callDeleteAudioDialog(item) {
      this.deleteAudioDialog.audioId = item.id;
      this.deleteAudioDialog.audioDescription = item.description;
      this.deleteAudioDialog.show = true;
    },
    deleteAudio(status) {
      if (!status) {
        this.setSnack({
          color: 'red',
          text: 'error',
        });
      } else {
        this.setSnack({
          color: 'green',
          text: 'saved',
        });
        this.updateAudioList();
      }

      this.deleteAudioDialog.show = false;
      this.deleteAudioDialog.audioId = null;
      this.deleteAudioDialog.audioDescription = null;
    },
  },
};
</script>
